<template>
  <div id="app">
    <div>
      <b-navbar toggleable="lg" type="dark" variant="dark">
        <b-navbar-brand href="/">Home</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item-dropdown text="Animations" right>
              <b-dropdown-item href="/animations/snow">Snow</b-dropdown-item>
              <b-dropdown-item href="/animations/rain">Rain</b-dropdown-item>
              <b-dropdown-item href="/animations/firework"
                >Firework</b-dropdown-item
              >
            </b-nav-item-dropdown>
            <b-nav-item-dropdown text="Games" right>
              <b-dropdown-item href="/games/moving-button"
                >Moving button</b-dropdown-item
              >
              <b-dropdown-item href="/games/tetris"
                >Tetris Game</b-dropdown-item
              >
              <b-dropdown-item href="/games/bubble"
                >Bubble Game</b-dropdown-item
              >
              <b-dropdown-item href="/games/color-bubble"
                >Coloured Bubble Game</b-dropdown-item
              >
              <b-dropdown-item href="/games/puzzle"
                >Fun Puzzle Game</b-dropdown-item
              >
            </b-nav-item-dropdown>
            <b-nav-item-dropdown text="Features" right>
              <b-dropdown-item href="/features/convert-listing-table"
                >Convert Listing To Table</b-dropdown-item
              >
            </b-nav-item-dropdown>
            <b-nav-item-dropdown text="Learning" right>
              <b-dropdown-item href="/learning/bubble-wording"
                >Bubble Wording</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>

    <section>
      <router-view></router-view>
    </section>
    <!-- <section>
      <slot name="sidebar"></slot>
    </section> -->
  </div>
</template>

<script>
export default {
  computed: {
    username() {
      return this.$route.params.username;
    },
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.dropdown-menu {
  background-color: grey !important;
}
</style>
